<template>
  <div id="c_invitation" v-loading="loading">
    <top></top>
    <div class="main">
      <!-- 左侧菜单 -->
      <navMenu :active="active"></navMenu>
      <!-- 右侧内容区域 -->
      <div class="content" v-loading="loading">
        <div class="go-back" @click="back">
          {{ lang === "cn" ? "返回" : "Back" }}
        </div>
        <div class="content-main">
          <div class="main-title">
            {{ lang === "cn" ? "自定义邀请函" : "Customize Invitation" }}
          </div>
          <div class="c_invitation_tips">
            <p>
              {{
                lang === "cn"
                  ? "1、上传图片需要注意空出文字和二维码位置，且上传的图片需符合法律法规要求"
                  : "1.When uploading images, ensure to reserve space for text and QR codes, and the uploaded images must comply with legal and regulatory requirements."
              }}
            </p>
            <p>
              {{
                lang === "cn"
                  ? "2、自定义的邀请函图片请自行下载保存"
                  : "2.Please download and save your customized invitation image by yourself."
              }}
            </p>
          </div>
          <div class="c_invitation_box">
            <div id="posterRef">
              <img :src="selectedBackground" alt="" />
              <div class="c_invitation_box_graffiti">
                <img
                  class="c_invitation_box_tag"
                  :src="
                    chooseBackground_index === 0
                      ? companyInformation.exhibitor_tag_cn
                      : companyInformation.exhibitor_tag_en
                  "
                  alt=""
                />
                <div class="c_invitation_box_logo">
                  <img :src="companyInformation.cover" alt="" />
                </div>
                <p class="c_invitation_box_company">
                  {{
                    chooseBackground_index === 0
                      ? companyInformation.title
                      : companyInformation.en_title
                  }}
                </p>
                <p class="c_invitation_box_booth">
                  {{
                    chooseBackground_index === 0 ? "展位号" : "Booth No."
                  }}：{{
                    chooseBackground_index === 0
                      ? companyInformation.hall_no + "馆 "
                      : "Hall " + companyInformation.hall_no
                  }}
                  {{ companyInformation.booth_no }}
                </p>
                <!-- <p class="c_invitation_box_website">
                  {{ companyInformation.company_url }}
                </p>
                <p class="c_invitation_box_address">
                  {{ companyInformation.address }}
                </p> -->
                <img
                  :src="miniProgramQRCode"
                  alt=""
                  class="c_invitation_box_miniProgramVisit"
                />
                <img
                  :src="exhibitionVisitQRCode"
                  alt=""
                  class="c_invitation_box_exhibitionVisit"
                />
              </div>
            </div>
            <div>
              <p>{{ lang === "cn" ? "选择背景：" : "Choose Background:" }}</p>
              <div class="c_invitation_background">
                <div
                  class="c_invitation_background_wrapper"
                  v-for="(item, index) in backgroundList"
                  :key="index"
                >
                  <img
                    :class="{ active: item.isActive }"
                    @click="chooseBackground(index)"
                    :src="item.image"
                    alt=""
                  />
                  <img
                    @click.stop="
                      handleDeleteCustomizeInvitationBackground(item)
                    "
                    src="../assets/close_icon.png"
                    alt=""
                  />
                </div>
                <el-upload
                  class="c_invitation_uploader"
                  :action="$uploadImgUrl"
                  :headers="headers"
                  :on-success="handleUploadSuccess"
                  :before-upload="beforeUpload"
                  :multiple="false"
                  :show-file-list="false"
                >
                  <i class="el-icon-plus"></i>
                  <p>
                    {{
                      lang === "cn" ? "建议尺寸：437*777 " : "Size: 437 * 777"
                    }}
                  </p>
                </el-upload>
              </div>
              <div class="c_invitation_button" @click="generateInvitation">
                {{ lang === "cn" ? "生成邀请函" : "Generate an Invitation" }}
              </div>
            </div>
          </div>
          <div
            class="c_invitation_made"
            v-if="alreadyMadeInvitationList.length > 0"
          >
            <p>
              {{
                lang === "cn" ? "已制作的邀请函" : "prepared invitation letter"
              }}
            </p>
            <div class="c_invitation_made_box">
              <div
                v-for="(item, index) in alreadyMadeInvitationList"
                :key="index"
                :ref="'invitation' + index"
              >
                <img :src="item.image" alt="" />
                <div class="c_invitation_made_mask" v-if="item.image !== ''">
                  <div @click="handleDownloadInvitation(item)">
                    {{ lang === "cn" ? "下载" : "Download" }}
                  </div>
                  <div @click="handleDeleteAlreadyMadeInvitation(item)">
                    {{ lang === "cn" ? "删除" : "Delete" }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import top from "../components/top.vue"; //头部
import navMenu from "../components/navMenu.vue"; //左侧步骤条
import html2canvas from "html2canvas";
import qrcode from "qrcode";
import {
  getCdsInvitationBackground,
  uploadCustomizeInvitationBackground,
  deleteCustomizeInvitationBackground,
  getAlreadyMadeCdsInvitation,
  generateCdsInvitation,
  deleteAlreadyMadeCdsInvitation,
  uploadCdsInvitationBase64,
  getCompanyInformation,
  getCdsInvitationQRCodeLink,
} from "../api/api";

export default {
  components: { top, navMenu },
  name: "cdsCustomizeInvitation",
  data() {
    return {
      stepMenuList: [],
      active: "",
      detail: "",
      lang: "",
      backgroundList: [],
      image1: require("../assets/loginbg.jpg"),
      image2: require("../assets/loginbg1.jpg"),
      alreadyMadeInvitationList: [],
      selectedBackground: "",
      companyInformation: {},
      headers: {},
      loading: false,
      exhibitionVisitQRCode: "",
      miniProgramQRCode: "",
      chooseBackground_index: 0,
    };
  },
  created() {
    this.loading = true;
    this.headers = {
      token: localStorage.getItem("token"),
    };
    let stepMenuList = JSON.parse(localStorage.getItem("menu"));
    this.stepMenuList = stepMenuList;
    var index = stepMenuList.findIndex(function (item) {
      return item.link_url == "/cdsInvitaion";
    });
    this.detail = stepMenuList[index];
    this.active = index;
    this.lang = localStorage.getItem("language");
    this.getInvitationBackground();
  },
  methods: {
    async getInvitationBackground() {
      // 默认样式：type = 0
      const res = await getCdsInvitationBackground();
      if (res.data.code == 1) {
        this.backgroundList = res.data.data.lists;
        this.backgroundList.forEach((item, index) => {
          item.isActive = false;
        });
        this.backgroundList[0].isActive = true;
        this.selectedBackground = this.backgroundList[0].image;
        this.getAlreadyMadeInvitation();
      } else {
        this.$message.error(res.data.msg);
      }
    },
    async getAlreadyMadeInvitation() {
      const res = await getAlreadyMadeCdsInvitation();
      if (res.data.code == "1") {
        this.alreadyMadeInvitationList = res.data.data.lists;
        this.getCompanyData();
      } else {
        this.$message.error(res.data.msg);
      }
    },
    async getCompanyData() {
      const res = await getCompanyInformation();
      if (res.data.code == 1) {
        this.companyInformation = res.data.data;
        if (this.companyInformation.is_partners === 1) {
          this.companyInformation.exhibitor_tag_cn = require("../assets/exhibitor_top_cn.png");
          this.companyInformation.exhibitor_tag_en = require("../assets/exhibitor_top_en.png");
        } else {
          if (this.companyInformation.level_tag === "金牌展商") {
            this.companyInformation.exhibitor_tag_cn = require("../assets/exhibitor_gold_cn.png");
            this.companyInformation.exhibitor_tag_en = require("../assets/exhibitor_gold_en.png");
          } else if (this.companyInformation.level_tag === "钻石展商") {
            this.companyInformation.exhibitor_tag_cn = require("../assets/exhibitor_diamond_cn.png");
            this.companyInformation.exhibitor_tag_en = require("../assets/exhibitor_diamond_en.png");
          } else {
            this.companyInformation.exhibitor_tag_cn = require("../assets/exhibitor_normal_cn.png");
            this.companyInformation.exhibitor_tag_en = require("../assets/exhibitor_normal_en.png");
          }
        }
        this.miniProgramQRCode = res.data.data.qrcode_img;
        this.getQRCodeLink();
      } else {
        if (this.lang === "cn") {
          this.$message.error(res.data.msg);
        } else {
          this.$message.error("Failed to retrieve exhibitor information!");
        }
      }
    },
    async getQRCodeLink() {
      let languageType;
      if (this.lang === "cn") {
        languageType = 1;
      } else {
        languageType = 2;
      }
      const res = await getCdsInvitationQRCodeLink(
        "languageType=" + languageType
      );
      console.log(res, 123123);
      if (res.data.code == 1) {
        qrcode.toDataURL(
          res.data.data.url,
          { width: 240, height: 240 },
          (err, url) => {
            if (err) {
              if (this.lang === "cn") {
                this.$message.error("生成报名观展二维码失败");
              } else {
                this.$message.error(
                  "Failed to generate exhibition registration QR code!"
                );
              }
            }
            this.exhibitionVisitQRCode = url;
          }
        );
      } else {
        if (this.lang === "cn") {
          this.$message.error(res.data.msg);
        } else {
          this.$message.error("Failed to retrieve QRCode Link!");
        }
      }
      this.loading = false;
    },
    chooseBackground(index) {
      this.backgroundList.forEach((item) => {
        item.isActive = false;
      });
      this.backgroundList[index].isActive = true;
      this.selectedBackground = this.backgroundList[index].image;
      this.chooseBackground_index = index;
    },
    async handleUploadSuccess(res) {
      const res2 = await uploadCustomizeInvitationBackground({
        image: res.data.uri,
      });
      if (res2.data.code == 1) {
        this.$message.success(res2.data.msg);
        this.getInvitationBackground();
      } else {
        this.$message.error(res2.data.msg);
      }
      this.loading = false;
    },
    beforeUpload(file) {
      this.loading = true;
      if (file.type !== "image/jpeg" && file.type !== "image/png") {
        this.$message.warning("上传的背景图必须为jpg或png格式");
        this.loading = false;
        return false;
      }
      if (file.size / 1024 / 1024 > 2) {
        this.$message.warning("上传的背景图文件大小不可超过2M");
        this.loading = false;
        return false;
      }
    },
    handleDeleteCustomizeInvitationBackground(item) {
      this.$confirm("是否确认要删除该自定义背景图？", "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        const res = await deleteCustomizeInvitationBackground({
          id: item.id,
        });
        if (res.data.code == 1) {
          this.$message.success(res.data.msg);
          this.getInvitationBackground();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    generateInvitation() {
      this.$confirm("确定要生成邀请函吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "success",
      }).then(async () => {
        this.loading = true;
        const response = await fetch(this.selectedBackground, {
          mode: "cors", // 明确使用CORS模式
          credentials: "same-origin", // 仅同源携带凭证
        });
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        // 将响应转换为图片URL
        const blob = await response.blob();
        const imageUrl = URL.createObjectURL(blob);
        this.selectedBackground = imageUrl;
        html2canvas(document.querySelector("#posterRef"), {
          useCORS: true,
          allowTaint: true,
          scale: 4,
        }).then(async (canvas) => {
          const imgData = canvas.toDataURL("image/webp");
          const res = await uploadCdsInvitationBase64({
            base64_image: imgData,
          });
          if (res.data.code == 1) {
            const res2 = await generateCdsInvitation({
              image: res.data.data.uri,
            });
            this.loading = false;
            if (res2.data.code == "1") {
              this.$message.success(res.data.msg);
              this.getAlreadyMadeInvitation();
            } else {
              this.$message.error(res.data.msg);
            }
          }
        });
      });
    },
    handleDownloadInvitation(item) {
      fetch(item.image)
        .then((response) => response.blob()) // 获取对象
        .then((blob) => {
          const blobUrl = URL.createObjectURL(blob); // 生成临时URL
          const link = document.createElement("a");
          link.href = blobUrl;
          link.download = "invitation.png"; // 设置下载文件名
          document.body.appendChild(link);
          link.click(); // 触发下载
          document.body.removeChild(link);
          URL.revokeObjectURL(blobUrl); // 释放内存
        })
        .catch((error) => console.error("下载失败:", error));
    },
    async handleDeleteAlreadyMadeInvitation(item) {
      const res = await deleteAlreadyMadeCdsInvitation({
        id: item.id,
      });
      if (res.data.code == "1") {
        this.$message.success(res.data.msg);
        this.getAlreadyMadeInvitation();
      } else {
        this.$message.error(res.data.msg);
      }
    },
    turnImageIntoCanvas() {
      return new Promise((resolve, reject) => {
        let imageUrl = this.selectedBackground;
        const image = new Image();
        image.crossOrigin = "Anonymous";
        image.src = imageUrl;
        image.onload = () => {
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");
          canvas.height = image.naturalHeight;
          canvas.width = image.naturalWidth;
          ctx.drawImage(image, 0, 0);
          const dataUrl = canvas.toDataURL();
          resolve(dataUrl);
        };
        image.onerror = () => {
          this.$message.error("操作失败！");
          reject();
        };
      });
    },
    back() {
      this.$router.back();
    },
  },
};
</script>
<style lang="scss" scoped>
.content-main {
  background-color: #fff;
  margin-top: 20px;
  border-radius: 8px;
  box-sizing: border-box;
  padding: 30px 20px 300px;

  .main-title {
    margin-bottom: 16px;
  }

  .c_invitation_tips {
    font-size: 14px;
    color: #666;

    p {
      margin-bottom: 10px;
    }
  }

  .c_invitation_box {
    margin-top: 40px;
    display: flex;

    > div:first-child {
      margin-right: 60px;
      width: 175px;
      height: 350px;
      position: relative;

      img {
        //width: 100%;
        height: 100%;
      }

      .c_invitation_box_graffiti {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        .c_invitation_box_tag {
          position: absolute;
          left: 50%;
          top: 96px;
          transform: translateX(-50%);
          object-fit: contain;
          height: 24px;
        }
        .c_invitation_box_logo {
          position: absolute;
          left: 50%;
          top: 126px;
          transform: translateX(-50%);
          height: 40px;
          width: 160px;
          display: flex;
          justify-content: center;
          align-items: center;
          img {
            max-height: 100%;
            max-width: 100%;
            height: auto !important;
          }
        }

        .c_invitation_box_company {
          width: 80%;
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          top: 168px;
          color: #004189;
          font-weight: 700;
          font-size: 9px;
          text-align: center;
        }

        .c_invitation_box_booth {
          //width: 100%;
          //display: flex;
          //align-items: center;
          //justify-content: center;
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          top: 190px;
          color: #004189;
          font-weight: 500;
          font-size: 7px;
          //text-align: center;
          background: #fff;
          box-sizing: border-box;
          border: 1px solid #004189;
          padding: 3px 13px;
          border-radius: 9px;
          white-space: nowrap;
          max-width: 70%;
          overflow: hidden;
          text-overflow: ellipsis;
          //line-height: 12px;
        }

        .c_invitation_box_website,
        .c_invitation_box_address {
          position: absolute;
          left: 18px;
          top: 250px;
          color: #fff;
          font-weight: 500;
          font-size: 6px;
        }

        .c_invitation_box_address {
          top: 264px;
        }

        .c_invitation_box_miniProgramVisit {
          position: absolute;
          left: 34px;
          top: 249px;
          width: 40px;
          height: 40px;
        }

        .c_invitation_box_exhibitionVisit {
          position: absolute;
          left: 101px;
          top: 249px;
          width: 40px;
          height: 40px;
        }
      }
    }

    > div:last-child {
      p {
        font-size: 14px;
        color: #2c2c2e;
        margin-bottom: 10px;
        margin-top: 10px;
      }

      .c_invitation_background {
        display: flex;
        align-items: center;
        margin-bottom: 56px;

        .c_invitation_background_wrapper {
          width: 87px;
          height: 175px;
          margin-right: 20px;
          position: relative;

          img:first-child {
            width: 100%;
            height: 100%;
            cursor: pointer;
            border: 2px solid transparent;
            box-sizing: border-box;
          }

          img:first-child.active {
            border: 2px solid #1677ff;
          }

          img:last-child {
            width: 20px;
            height: 20px;
            position: absolute;
            top: 4px;
            right: 4px;
            cursor: pointer;
          }
        }

        .c_invitation_uploader {
          width: 150px;
          height: 150px;
          border: 1px dashed #d9d9d9;
          border-radius: 6px;
          cursor: pointer;

          /deep/ .el-upload {
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            position: relative;

            i {
              color: #8c939d;
              font-size: 24px;
            }

            p {
              color: rgb(102, 102, 102);
              font-size: 12px;
              position: absolute;
              width: 100%;
              text-align: center;
              left: 0;
              bottom: 0;
              transform: translateY(150%);
              margin: 0;
            }
          }
        }

        .c_invitation_uploader:hover {
          border-color: #1677ff;
        }
      }

      .c_invitation_button {
        width: 148px;
        height: 38px;
        background: linear-gradient(270deg, #fe4d34 0%, #fc933f 100%);
        border-radius: 6px;
        color: #fff;
        font-size: 12px;
        font-weight: 500;
        cursor: pointer;
        text-align: center;
        line-height: 38px;
      }
    }
  }

  .c_invitation_made {
    color: #022a48;
    font-weight: 500;
    margin-top: 60px;

    .c_invitation_made_box {
      display: flex;
      align-items: flex-start;
      flex-wrap: wrap;

      > div {
        width: 175px;
        height: 350px;
        margin-top: 16px;
        margin-right: 40px;
        position: relative;

        img {
          width: 100%;
          height: 100%;
        }

        .c_invitation_made_mask {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          background-color: rgba(0, 0, 0, 0.5);
          visibility: hidden;
          opacity: 0;
          transition: opacity 0.3s ease, visibility 0.3s ease;

          div {
            width: 110px;
            height: 40px;
            font-size: 14px;
            color: #fff;
            line-height: 40px;
            text-align: center;
            border-radius: 4px;
            cursor: pointer;
            margin: 0 auto;
          }

          div:first-child {
            background-color: #1677ff;
            margin-top: 100px;
          }

          div:last-child {
            background-color: #ff4d4f;
            margin-top: 40px;
          }
        }
      }

      > div:hover .c_invitation_made_mask {
        visibility: visible;
        opacity: 1;
      }
    }
  }
}

/deep/ .el-loading-spinner {
  top: 30%;
}
</style>

methods: {
async loadImage(url) {
try {
const response = await fetch(url, {
mode: 'cors', // 明确使用CORS模式
credentials: 'same-origin' // 仅同源携带凭证
});

if (!response.ok) {
throw new Error(`HTTP error! Status: ${response.status}`);
}

// 将响应转换为图片URL
const blob = await response.blob();
const imageUrl = URL.createObjectURL(blob);
return imageUrl;
} catch (error) {
console.error('图片加载失败:', error);
return '/default-image.jpg'; // 加载失败时返回默认图片
}
}
}